module.exports = __webpack_public_path__ + "img/experience-icon.50304fab.svg";